import { useMemo } from 'react';

import { useDraftDefinition } from '../contexts/DraftDefinitionProvider';
import type { DraftSteps } from '../utils/types';

export const useDraftSteps = () => {
  const { fieldDefinitions } = useDraftDefinition();

  const steps = useMemo(() => {
    const draftSteps = Object.keys(fieldDefinitions).filter(
      (step) => Object.keys(fieldDefinitions[step]).length > 0
    );

    // Also add final review step
    return [...draftSteps, 'review_and_submit'] as DraftSteps[];
  }, [fieldDefinitions]);

  return steps;
};
